import { Component, EventEmitter, Output } from '@angular/core';
import { Prompt } from '@app/shared/models/prompt.model';
import { PromptService } from "@services/prompt/prompt.service";
import {  Subject, take } from 'rxjs';

@Component({
  selector: 'app-saved-prompts',
  templateUrl: './saved-prompts.component.html',
  styleUrls: ['./saved-prompts.component.css']
})
export class SavedPromptsComponent {
  @Output() promptSelectEvent = new EventEmitter<Prompt>();
  @Output() backToChatEvent = new EventEmitter<boolean>();
  result$ = new Subject<boolean>();

  constructor(private promptService: PromptService) {}

  promptSelected(prompt: any): void {
    this.promptService.updateUseSavedPrompt(prompt.id!)
    .pipe(take(1))
    .subscribe({
      next: () =>
        this.result$.next(true),
      error: () =>
        this.result$.next(false),
    });
    this.promptSelectEvent.emit(prompt);
  }

  showChat(event: any): void {
    event?.preventDefault();
    this.backToChatEvent.emit(true);
  }
}
